export const getDeepSearchWrapperStyles = () => ({
  paddingBottom: '0',
  overflow: 'hidden',
});

export const deepSearchContentStyles = {
  height: '100%',
};
